import styled from "styled-components";
import { HorizontalDivider } from "@common/LifeAtDivider/LifeAtDivider";
import AppModeDropdown from "../../../../app/LifeAtApp/TopNavigation/TopNavigationComponents/AppModeDropdown";
import { ProjectsSidebarList } from "../../components/TaskProjectFilterList";
import { TaskTagFilterSidebarList } from "../../components/TaskTagFilterSidebarList";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    padding: 10px 5px;

    color: ${(props) => props.theme.textColorPrimary};
    background-color: ${(props) => props.theme.backgroundPrimary};
    border-right: 1px solid ${(props) => props.theme.borderPrimary};
    overflow-y: scroll;
`;

export function PlannerFilteringSidebar() {
    return (
        <Container>
            <AppModeDropdown />
            <ProjectsSidebarList />
            <HorizontalDivider widthCssValue={"100%"} />
            <TaskTagFilterSidebarList />
        </Container>
    );
}
